var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l(((new Array(_vm.max))),function(_,index){return _c('Star',{key:index + 1,attrs:{"position":index + 1,"value":_vm.value},nativeOn:{"click":function($event){return _vm.$emit('input', index + 1)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }